// extracted by mini-css-extract-plugin
module.exports = {"row":"WorkloadUserRow_row__1lT_l","timesheet-user-days":"WorkloadUserRow_timesheet-user-days__1jtn1","nonProduction":"WorkloadUserRow_nonProduction__2rBUd"};